<template>
  <div v-if="user" class="songs ">
    <div v-if="user.type=='user'">
      <div class="text-center"><v-icon color="white" size="30px">mdi-music</v-icon></div>
      <div class="text-center mb-3 mt-2 white--text"><h2 >My Songs</h2></div>

      <!-- <div class="mt-5"><AddSong :current_user_id="user.user_id" @projectAdded="forceRerender"/></div> -->
      
      
      <div class="text-center my-5" v-if="!hasLoaded">
        <v-progress-circular color="white" indeterminate size="30"></v-progress-circular>
      </div>
      
      <div v-else-if="hasLoaded">
        
        <v-container  v-if="sortedSongs.length == 0">
          <div class="noSongsMsg" style="max-width:800px;margin-left:auto;margin-right:auto">
            <div class=" text-center white--text">
              You have uploaded no songs so far. 
            </div>
            <div class="mt-2 text-center white--text">
              <router-link class="rl-no-dec syn_blue_button--text" :to="{ name: 'AddNewSong'}">Upload a Song</router-link> and submit it to one of the <router-link class="rl-no-dec syn_blue_button--text" :to="{ name: 'Artists'}">SynthFeed Artists</router-link>.
            </div>
          </div>
          
        </v-container>

        <div class="mt-5 text-center">
          <v-btn depressed class="linkHover" color="syn_green_shadow lighten-2" dark :to="{ name: 'AddNewSong'}">Add New Song</v-btn>
        </div>
        

        <v-container style="max-width:1200px" v-if="sortedSongs.length > 0"  class="my-5 d-none d-md-flex">
          <SongsEPDetailedMedium  style="width:100% !important" :sortedSongs="sortedSongs" :submissions="submissions" :user="user" />
        </v-container>

        <v-container v-if="sortedSongs.length > 0" class="my-5 d-none d-sm-flex d-md-none">
          <SongsEPDetailedSmall style="width:100% !important" :sortedSongs="sortedSongs" :submissions="submissions" :user="user" />
          
        </v-container>

        <v-container v-if="sortedSongs.length > 0" class="my-5 d-flex d-sm-none">
          <SongsEPDetailedExtraSmall style="width:100% !important" :sortedSongs="sortedSongs" :submissions="submissions" :user="user" />
          
        </v-container>
      </div>


    </div>
    <Overlay :overlay="overlay" />
  </div>
</template>
<script>
// import AddSong from '../components/songs/AddSong'
import SongsEPDetailedMedium from '@/components/songs/songComponents/SongsEPDetailedMedium'
import SongsEPDetailedSmall from '@/components/songs/songComponents/SongsEPDetailedSmall'
import SongsEPDetailedExtraSmall from '@/components/songs/songComponents/SongsEPDetailedExtraSmall'
import Overlay from '@/components/layout/Overlay'
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
import moment from 'moment'

const db = fb.db
const storage = fb.storage



export default {
  name: 'Songs',
  components: {
    // AddSong,
    SongsEPDetailedMedium,
    SongsEPDetailedSmall,
    SongsEPDetailedExtraSmall,
    Overlay
  },
  data() {
    return {
      user: null,
      songs: [],
      submissions: [],
      loadingDelete: false,
      dialog: false,
      overlay: true,
      hasLoaded:false,
    }
  },
  methods:{
    forceRerender() {
      this.$router.go()
    },
    filterSubmissions(song_id){
      let filteredSubmissions = this.submissions.filter(function(event){
        return event.song_id == song_id
      })
      return filteredSubmissions
    },
    expiryHours(timestamp){
      var now = moment(Date.now()); //current time
      var end = moment(timestamp+259200000); // due date
      var duration = moment.duration(end.diff(now));
      var hours = duration.asHours();
      var floorHours = Math.floor(hours)
      var output
      if (floorHours > 1) {
          output = floorHours + " hours"
      } else if (floorHours == 1){
          output = floorHours + " hour"
      } else {
          output = "OVERDUE"
      }

      return output
    },
  },
  created() {
    // let user = firebase.auth().currentUser
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // this.user = user
        let ref = db.collection('users')
        
        const that = this

        // ************************* get current user ************************* 
        ref.where('user_id','==',firebase.auth().currentUser.uid).get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            this.user = doc.data(),
            this.user.id = doc.id
            this.user.email = user.email
          })
        })
        .then(() =>{
          // ************************* retrieve user songs from database ************************* 
          db.collection('songs').where('user_id','==',this.user.user_id)

          .get()
          .then(function(querySnapshot) {
            if (querySnapshot.empty) {
              that.hasLoaded=true
            } else {

              querySnapshot.forEach(function(doc) {
                if (!doc.data().inProgress){
                  storage.ref().child(doc.data().audioPath).getDownloadURL().then(function(url) {
                    return url
                  }).then((url)=>{
                    that.songs.unshift({
                      user_id: doc.data().user_id,
                      title: doc.data().title,
                      genre: doc.data().genre,
                      comments: doc.data().comments,
                      timestamp: moment(doc.data().timestamp).format('lll'),
                      song_id: doc.id,
                      icon: doc.data().icon,
                      audioPath: doc.data().audioPath,
                      audio: url
                    })     
                  }).then(()=> {
                    that.hasLoaded=true
                  })
                } else {
                  console.log(doc.data());
                  var newSongRef = db.collection("songs").doc(doc.id);

                    newSongRef.get().then(function(doc) {
                        if (doc.exists) {
                            newSongRef.delete().then(function() {
                                // console.log("Document successfully deleted!");
                            })
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    })
                }
                
              })
            }
          })
          .then(()=>{
          
            // submissions
            db.collection('submissions').where('user_id','==',this.user.user_id)
            .onSnapshot((snapshot) => {
              snapshot.docChanges().forEach(change => {
                let subRef = change.doc.data()
                if(change.type == 'added') {
                  storage.ref().child(subRef.artist_avatarPath).getDownloadURL().then(function(url) {
                    return url

                  }).then((url)=>{
                    this.submissions.unshift({
                        artist_id: subRef.artist_id,
                        artist_accomplishments: subRef.artist_accomplishments,
                        artist_avatarPath: subRef.artist_avatarPath,
                        artist_avatar: url,
                        artist_bio: subRef.artist_bio,
                        artist_genre: subRef.artist_genre,
                        artist_labels: subRef.artist_labels,
                        artist_name: subRef.artist_name,
                        artist_plays: subRef.artist_plays,
                        artist_price: subRef.artist_price,
                        artist_pricingOption: subRef.artist_pricingOption,
                        artist_yearsExperience: subRef.artist_yearsExperience,

                        artist_earning: subRef.artist_earning,
                        artist_earned: subRef.artist_earned,

                        returned: subRef.returned,

                        song_comments: subRef.song_comments,
                        song_genre: subRef.song_genre,
                        song_id: subRef.song_id,
                        song_audioPath: subRef.song_audioPath,
                        song_title: subRef.song_title,
                        song_icon: subRef.song_icon,

                        timestamp: subRef.timestamp,
                        timestamp_asDate: moment(subRef.timestamp).format('lll'),
                        deadline_72hr: moment((subRef.timestamp)+259200000).format('lll'),
                        

                        submission_id: change.doc.id,

                        user_id: subRef.user_id,
                        user_name: subRef.user_name, //new addition
                        
                        type: subRef.type,
                        status: subRef.status,
                        earning_id: subRef.earning_id
                    })
                  }).then(()=>{
                    that.hasLoaded=true
                  })
                }
              })
            }) 
          })
          .then(()=>{
            this.overlay = false
            // this.hasLoaded=true
          })
          // .onSnapshot((snapshot) => {
          //   snapshot.docChanges().forEach(change => {
          //     if(change.type == 'added') {
                
                
          //       storage.ref().child(change.doc.data().audioPath).getDownloadURL().then(function(url) {
          //         return url
          //       }).then((url)=>{
          //         this.songs.unshift({
          //           user_id: change.doc.data().user_id,
          //           title: change.doc.data().title,
          //           genre: change.doc.data().genre,
          //           comments: change.doc.data().comments,
          //           timestamp: moment(change.doc.data().timestamp).format('lll'),
          //           song_id: change.doc.id,
          //           icon: change.doc.data().icon,
          //           audioPath: change.doc.data().audioPath,
          //           audio: url
          //         })     
          //       })
          //     }
          //   })
          // })          
        })
        
              
      } else {
        this.user = null
        this.overlay = false
      }
    })
  },
  computed: {
    sortedSongs: function() {
      return this.songs.slice(0).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    },
    
  },
    
}
</script>

<style>



.chip-returned-true{
  /* background-color: #05AF2A !important; */
  background-color: transparent !important;
  border: rgba(5, 175, 42, 1) 1px solid !important;
  color: rgba(5, 175, 42, 1) !important;
}

.chip-returned-false{
  /* background-color: orange !important; */
  background-color: transparent !important;
  border: rgba(255, 165, 0, 1) 1px solid !important;
  color: rgba(255, 165, 0, 1) !important;
}
.chip-expired{
  /* background-color: red !important; */
  background-color: transparent !important;
  border: rgba(255, 0, 0, 1) 1px solid !important;
  color: rgba(255, 0, 0, 1) !important;
}

.cardTitle{
    font-size: 1.7em;
    margin-left: auto;
    margin-right: auto;
}

.v-divider-color-main{
  background-color:rgba(255,255,255,1) !important;
  /* border: red 2px solid !important */
  /* border-color: red !important; */
}
.v-divider-color-sec{
  background-color:rgba(255,255,255,0.3) !important;
  /* background-color:red !important; */
  /* border-width:1px; */
}

audio { width: 80%; }

.noSongsMsg{
          -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
         -o-animation: fadein 1s; /* Opera < 12.1 */
            animation: fadein 1s;
            border: rgba(255,255,255,0.3) 1px solid;
    /* background-color:rgba(5,25,43,0.4); */
    border-radius: 5px;
    background-color: rgba(5,25,43,0.8) !important; 
    padding: 20px;
}

</style>